import React from 'react';
import Analytics from './Analytics';

const Metrics = ({ apiBaseUrl, apiKey, selectedCompany }) => {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Usage Metrics</h2>
      <Analytics 
        selectedCompany={selectedCompany} 
        apiBaseUrl={apiBaseUrl} 
        apiKey={apiKey} 
      />
    </div>
  );
};

export default Metrics;
